/**
 * @generated SignedSource<<a3a11b99e152ccfcdeffb669dca7b1f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsPublishedWithin24HoursQueueItemConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly publishedDate?: number | null | undefined;
    };
  }>;
  readonly " $fragmentType": "helpersIsPublishedWithin24HoursQueueItemConnection";
};
export type helpersIsPublishedWithin24HoursQueueItemConnection$key = {
  readonly " $data"?: helpersIsPublishedWithin24HoursQueueItemConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsPublishedWithin24HoursQueueItemConnection">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsPublishedWithin24HoursQueueItemConnection"
};

(node as any).hash = "ddb8454f2545902de3fae50ac0d79388";

export default node;
